import { FAQScreenWeb } from '@/modules/faq/components/FAQScreenWeb';
import React from 'react';

export default function FAQCategoryScreenWebRoute() {
  return <FAQScreenWeb />;
}
